export interface LogbookReportParams {
  date?: string;
  driverId: string;
}
